import { Base } from "../../../base/components/base"
import { Button } from '../../../base/components/native/button'
import { Img } from "../../../base/components/native/img"
import { Span } from "../../../base/components/native/span"
import { CENTER } from "../../../base/helpers/style"
import { IMAGES } from "../../../configs/images"

export const GoogleButton = () => {
    const base = Button()
    const google = Img(IMAGES.ICONS.GOOGLE, { width: 24 })
    const txt = Span('ورود یا ثبت‌نام با حساب گوگل')
    txt.cssClass({
        marginRight: '10px',
    })

    base.append(google, txt)
    base.cssClass({
        ...CENTER,
        border: 'none',
        color: 'white',
        backgroundColor: '#286ddf',
        borderRadius: '24px',
        height: '48px',
        padding: '10px',
        fontSize: '16px',
        wordSpacing: '-3px',
        width: '100%'
    })

    base.el.onclick = async () => {
        base.disable()
        // txt.text('در حال ورود')
        base.emit('request-login')
    }

    return base
}